<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <b-card>
    <p class="font-weight-bolder">Cancellation Reasons</p>

    <section class="call-stats__items" v-if="!loading">
      <b-form-select v-model="activeChart" class="mb-2" :class="{'disabled': loading}">
        <b-form-select-option value="prison">Cancellation reasons (Resident)</b-form-select-option>
        <b-form-select-option value="visitor">Cancellation reasons (Caller)</b-form-select-option>
      </b-form-select>

      <section>
        <div v-if="activeChart === 'prison'">
          <apexchart class="pie-custom" v-if="stats.prison_reasons.length > 0" key="prison-chart"
                     :options="chartPrison.options" type="pie" :series="chartPrison.series.data"></apexchart>
          <p v-else>No cancellation reasons from date range selected</p>
        </div>

        <div v-if="activeChart === 'visitor'">
          <apexchart class="pie-custom" v-if="stats.visitor_reasons.length > 0" key="visitor-chart"
                     :options="chartVisitor.options" type="pie" :series="chartVisitor.series.data"></apexchart>
          <p v-else>No cancellation reasons from date range selected</p>
        </div>
      </section>
    </section>

    <section v-else class="d-flex justify-center pb-6 pt-8 flex-wrap">
      <p class="full-width d-flex justify-content-center"><b-spinner variant="primary"></b-spinner>
        <span class="d-inline-block ml-2">Getting Stats...</span>
      </p>
    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  import { mapState } from 'vuex';
  //  import StatisticCardWithLineChart from '@core/components/statistics-cards/StatisticCardWithLineChart.vue'
  import BiStatsService from '../../../services/BiStatsService';
  import HelperService from '../../../services/HelperService';

  export default {
    components: {
      // StatisticCardWithLineChart,
    },
    props: {
      filters: {
        required: true,
        type: Object,
      },
    },
    data() {
      return {
        helperService: new HelperService(),
        loading: true,
        stats: null,
        activeChart: 'prison',
        chartPrison: {},
        chartVisitor: {},
        chart: {
          series: {
            name: 'Cancellation Reason',
            data: [],
          },
          options: {
            colors: [],
            labels: [],
            legend: {
              position: 'bottom',
            },
            tooltip: {
              enabled: false,
            },
          },
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
            },
            export: {
              csv: {
                filename: 'chart',
              },
            },
          },
        },
      };
    },
    computed: {
      ...mapState({
        compareMode: state => state.stats.compareMode,
      }),
    },
    watch: {
      filters: {
        handler() {
          this.getCancellationStats();
        },
        deep: true,
      },
    },
    mounted() {
      this.chart.options.colors = this.helperService.getChartColors();
      this.getCancellationStats();
    },
    methods: {
      getCancellationStats() {
        this.loading = true;

        BiStatsService.getCancellationReasons(this.filters).then(res => {
          this.stats = res.data;
          this.setUpChart('chartPrison', this.stats.prison_reasons);
          this.setUpChart('chartVisitor', this.stats.visitor_reasons);
        }).catch(err => {
          console.log('could not get cancellation reason', err);
          this.$toast.error('Could not get cancellation reason stats, please refresh and try again', {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
      },
      setUpChart(chartName, reasons) {
        const chart = JSON.parse(JSON.stringify(this.chart)); // deep clone

        chart.series.data = [];
        chart.options.labels = [];

        const newReasons = reasons.length > 5 ? this.getTopReasons(reasons, 5) : reasons;

        newReasons.forEach(reason => {
          chart.series.data.push(reason.total);
          chart.options.labels.push(reason.reason.substring(0, 50));
        });

        this[chartName] = chart;
      },
      getTopReasons(reasons, amount) {
        const sortedReasons = [];
        const other = {
          total: 0,
          reason: 'Other',
        };

        reasons.sort((a, b) => b.total - a.total);

        reasons.forEach((reason, index) => {
          if (index < amount - 1) {
            sortedReasons.push(reasons[index]);
          } else {
            other.total += 1;
          }
        })

        sortedReasons.push(other);
        return sortedReasons;
      },
    },
  };
</script>
